/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCashManagementOverview = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v9h-2V4H4v12h6v2H2zm5.111 4h9.778v1c0 .15.026.23.04.263a.12.12 0 0 0 .03.047.115.115 0 0 0 .05.023H18V10h-2v-.933A2.082 2.082 0 0 1 15.07 8H8.93A2.113 2.113 0 0 1 8 9.067v1.866A2.088 2.088 0 0 1 8.93 12H14v2H7.111v-1a.68.68 0 0 0-.04-.263.12.12 0 0 0-.03-.047.11.11 0 0 0-.051-.023H6V7.333h.99a.107.107 0 0 0 .05-.023.118.118 0 0 0 .03-.047A.675.675 0 0 0 7.112 7zm10.182 6.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L16.414 22H12v-4.414zM14 18.414V20h1.586l4-4L18 14.414zM10 20v2H2v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCashManagementOverview as CashManagementOverview };
